import type { ProcedureRow } from "../api/use-procedures";

/**
 * The API qualifies the decision (`classify-decision.ts`, next to the history
 * classifier); this file only maps its verdict onto a skin. The wording rules
 * used to live here, which meant a jurist correcting one had to know it was the
 * browser — and not the server — that decided won from lost.
 */
export type DecisionOutcome = NonNullable<ProcedureRow["legalRegistry"]>["decisionOutcome"];

/** Procedure document types that carry the court's ruling. */
export const DECISION_DOCUMENT_TYPES = ["COURT_DECISION", "JUDGEMENT_OF_DISMISSAL"];

/** Badge skin per outcome, in the house `bg-50 / text-700 / ring-600/20` anatomy. */
export const OUTCOME_BADGE_CLASSES: Record<DecisionOutcome, string> = {
  won: "bg-green-50 text-green-700 ring-green-600/20",
  lost: "bg-red-50 text-red-700 ring-red-600/20",
  unknown: "bg-gray-50 text-gray-700 ring-gray-600/20",
};

export const OUTCOME_DOT_CLASSES: Record<DecisionOutcome, string> = {
  won: "bg-green-500",
  lost: "bg-red-500",
  unknown: "bg-gray-400",
};

/** Panel banner — same semantics mapped onto the shared Alert variants. */
export const OUTCOME_ALERT_VARIANT: Record<DecisionOutcome, "success" | "error" | "default"> = {
  won: "success",
  lost: "error",
  unknown: "default",
};
